import React, { useEffect, useState } from "react";
import useControlPanel from "src/hooks/useControlPanel";
import ControlPanelSystem from "src/components/controlPanelSystem/ControlPanelSystem";
import Pagination from "src/components/Pagination/Pagination";
import useDebounce from "src/hooks/useDebounce";
import {
  getEmployees,
  removeEmployee,
  resetPassword,
} from "src/apis/System/employee.api";
import { Notify, NotifyConfirm } from "src/components/notify/Notify";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import { path } from "src/constants/path";
import EmployeeControlPanel from "../../components/ControlPanel/EmployeeControlPanel";
import EmployeeTable from "../../components/Table/EmployeeTable";

const initEmployeeData = {
  list: [],
  total_record: 0,
};

const titlePage = "Employees";

const Employees = () => {
  const permissionsAccessControl = useGetPermissionAccessControl();

  const {
    page,
    searchKey,
    numberPage,
    setNumberPage,
    limit,
    setLimit,
    status,
    setStatus,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    handleInputChange,
    handleChangePage,
  } = useControlPanel();

  const [employeeData, setEmployeeData] = useState(initEmployeeData);
  let search = useDebounce(searchKey, 500);

  useEffect(() => {
    const query = {
      page: numberPage,
      limit,
      searchKey: search,
      startDate,
      endDate,
      status,
    };
    getEmployees(query, (result) => {
      setEmployeeData({ ...result });
    });
  }, [endDate, limit, numberPage, page, search, startDate, status]);

  useEffect(() => {
    setNumberPage(page);
  }, [page, setNumberPage, status]);

  const handleDelete = (id) => {
    NotifyConfirm("warning", "Are you delete it ?", (result) => {
      if (result.isConfirmed) {
        // * Ưu tiên render giao diện trước
        const employeeDataFilter = employeeData.list.filter(
          (employee) => employee.id !== id
        );
        setEmployeeData((prev) => {
          return {
            ...prev,
            list: [...employeeDataFilter],
          };
        });
        Notify("success", "Deleted!");

        // * Sau đó mới gọi API remove employee
        removeEmployee(id);
      }
    });
  };
  const handleResetPass = (id) => {
    NotifyConfirm("warning", "Are you reset password ?", (result) => {
      if (result.isConfirmed) {
        Notify("success", "reset password success!");
        // * Sau đó mới gọi API reset pass
        resetPassword({ employeeId: id });
      }
    });
  };

  return (
    <div>
      <div className="page-header">
        <h2>{titlePage}</h2>
      </div>
      <EmployeeControlPanel permissionsAccessControl={permissionsAccessControl}>
        <ControlPanelSystem
          searchKey={searchKey}
          handleInputChange={(e) => handleInputChange(e)}
          limit={limit}
          setLimit={setLimit}
          setNumberPage={setNumberPage}
          status={status}
          setStatus={setStatus}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      </EmployeeControlPanel>
      {/* <EmployeeTable
        permissionsAccessControl={permissionsAccessControl}
        employees={employeeData?.list || []}
        handleResetPass={handleResetPass}
        handleDelete={handleDelete}
        status={status}
      /> */}
      <EmployeeTable
        data={employeeData?.list}
        employees={employeeData?.list || []}
        handleResetPass={handleResetPass}
        handleDelete={handleDelete}
        status={status}
      />
      <Pagination
        pathname={path.systemEmployee}
        page={numberPage}
        handleChangePage={(page) => handleChangePage(page)}
        limit={limit}
        pageSize={employeeData.total_record}
      />
    </div>
  );
};

export default Employees;
